<template>
  <!--
    Un formulario que todavía no tiene sus valores: rótulo encima, caja del
    campo debajo (38 px, 44 con el dedo, como UiInput) y, si se pide, la fila
    de botones al final.

    Se pone DENTRO de la tarjeta donde irá el formulario: la tarjeta (con su
    título, que ya se sabe) se pinta desde el principio y solo espera lo de
    dentro.
  -->
  <div class="sk-form" :class="{ 'sk-form--two': columns === 2 }" role="status" aria-busy="true">
    <span class="sr-only">{{ uiLabel('loading') }}</span>

    <div class="sk-form__grid" aria-hidden="true">
      <div
        v-for="field in fields"
        :key="field"
        class="sk-form__field"
        :class="{ 'sk-form__field--wide': textarea && field === fields }"
      >
        <span class="sk-form__label"><UiSkeleton height="0.75em" :width="LABEL[field % LABEL.length]" /></span>
        <UiSkeleton
          :variant="textarea && field === fields ? 'block' : 'field'"
          :height="textarea && field === fields ? '96px' : undefined"
        />
      </div>
    </div>

    <div v-if="actions" class="sk-form__actions" aria-hidden="true">
      <UiSkeleton variant="button" width="96px" />
      <UiSkeleton variant="button" width="120px" />
    </div>
  </div>
</template>

<script setup>
import UiSkeleton from './UiSkeleton.vue'
import { uiLabel } from '../utils/labels'

defineProps({
  fields: { type: Number, default: 6 },
  // 1 o 2. Con 2, la rejilla pasa a una columna en cuanto no caben dos de
  // 15 rem — en un teléfono siempre.
  columns: {
    type: Number,
    default: 1,
    validator: value => value === 1 || value === 2,
  },
  // El último campo es un área de texto (notas, descripción), a todo el ancho.
  textarea: Boolean,
  // La fila de Cancelar/Guardar del pie.
  actions: { type: Boolean, default: true },
})

const LABEL = ['32%', '44%', '26%', '38%', '30%', '48%']
</script>

<style scoped>
/* Lo que separa dos UiField en un formulario del ERP: `--space-4`. */
.sk-form__grid { display: grid; gap: var(--space-4); }
.sk-form--two .sk-form__grid {
  grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr));
  column-gap: var(--space-5);
}
.sk-form__field { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.sk-form__field--wide { grid-column: 1 / -1; }
/* El rótulo de UiField: texto sm, una línea. */
.sk-form__label { display: flex; align-items: center; height: calc(var(--text-sm) * 1.55); }

.sk-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  margin-top: var(--space-6);
}
</style>
